import { render } from "./PosPrescription.vue?vue&type=template&id=203f41aa&scoped=true"
import script from "./PosPrescription.vue?vue&type=script&lang=js"
export * from "./PosPrescription.vue?vue&type=script&lang=js"

import "./PosPrescription.vue?vue&type=style&index=0&id=203f41aa&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-203f41aa"]])

export default __exports__